import { create } from 'zustand';
import { coverageBlockedDetails, type CoverageBlockedDetails } from '../utils/coverageModel';

/**
 * FIX-D300-S2 (D-300 sec.2-3) — a 409 CUSTOMER_NO_COVERAGE from ANY place (▶ in a list, the home page, the composer,
 * the chat dock, a manual log, "יצירת משימה מהקריאה") opens ONE dialog with the message and the only action
 * "שליחת הודעה למנהל" (`CoverageHost`, always mounted in the layout). Only the switch "חסימת עבודה ללקוח בלי
 * כיסוי" makes the server answer so; with it off this store is never used.
 */
interface CoverageState {
  blocked: CoverageBlockedDetails | null;
  /** Open the dialog for a ticket (the 409's details, or the ticket page's own data). */
  open: (details: CoverageBlockedDetails) => void;
  close: () => void;
}

export const useCoverageStore = create<CoverageState>((set) => ({
  blocked: null,
  open: (details) => set({ blocked: details }),
  close: () => set({ blocked: null }),
}));

/** Called by the API client with every error body: opens the dialog for a 409 CUSTOMER_NO_COVERAGE. */
export function offerCoverageRequest(err: unknown): void {
  const details = coverageBlockedDetails(err);
  if (details) useCoverageStore.getState().open(details);
}
